__turbopack_context__.v({
  "bookingContainer": "booking-widget-module-scss-module__H5YkTa__bookingContainer",
  "bookingPopup": "booking-widget-module-scss-module__H5YkTa__bookingPopup",
  "bookingPopupBackground": "booking-widget-module-scss-module__H5YkTa__bookingPopupBackground",
  "bookingWrapper": "booking-widget-module-scss-module__H5YkTa__bookingWrapper",
  "boxSize": "booking-widget-module-scss-module__H5YkTa__boxSize",
  "buttonMargin": "booking-widget-module-scss-module__H5YkTa__buttonMargin",
  "calendarToggle": "booking-widget-module-scss-module__H5YkTa__calendarToggle",
  "close": "booking-widget-module-scss-module__H5YkTa__close",
  "closeButton": "booking-widget-module-scss-module__H5YkTa__closeButton",
  "closeContainer": "booking-widget-module-scss-module__H5YkTa__closeContainer",
  "error": "booking-widget-module-scss-module__H5YkTa__error",
  "field": "booking-widget-module-scss-module__H5YkTa__field",
  "fieldGroup": "booking-widget-module-scss-module__H5YkTa__fieldGroup",
  "fieldSeparator": "booking-widget-module-scss-module__H5YkTa__fieldSeparator",
  "fieldWrapper": "booking-widget-module-scss-module__H5YkTa__fieldWrapper",
  "fieldWrapperActive": "booking-widget-module-scss-module__H5YkTa__fieldWrapperActive",
  "fieldWrapperRoomGuests": "booking-widget-module-scss-module__H5YkTa__fieldWrapperRoomGuests",
  "groupHalf": "booking-widget-module-scss-module__H5YkTa__groupHalf",
  "hint": "booking-widget-module-scss-module__H5YkTa__hint",
  "input": "booking-widget-module-scss-module__H5YkTa__input",
  "inputField": "booking-widget-module-scss-module__H5YkTa__inputField",
  "inputWrapper": "booking-widget-module-scss-module__H5YkTa__inputWrapper",
  "label": "booking-widget-module-scss-module__H5YkTa__label",
  "margin": "booking-widget-module-scss-module__H5YkTa__margin",
  "popupHint": "booking-widget-module-scss-module__H5YkTa__popupHint",
  "promoText": "booking-widget-module-scss-module__H5YkTa__promoText",
  "qty": "booking-widget-module-scss-module__H5YkTa__qty",
  "qtySelector": "booking-widget-module-scss-module__H5YkTa__qtySelector",
  "roomTitle": "booking-widget-module-scss-module__H5YkTa__roomTitle",
  "scaler": "booking-widget-module-scss-module__H5YkTa__scaler",
  "selector": "booking-widget-module-scss-module__H5YkTa__selector",
  "selectorClose": "booking-widget-module-scss-module__H5YkTa__selectorClose",
  "selectorOpen": "booking-widget-module-scss-module__H5YkTa__selectorOpen",
  "separator": "booking-widget-module-scss-module__H5YkTa__separator",
  "showDesktop": "booking-widget-module-scss-module__H5YkTa__showDesktop",
  "showMobile": "booking-widget-module-scss-module__H5YkTa__showMobile",
  "thin": "booking-widget-module-scss-module__H5YkTa__thin",
  "title": "booking-widget-module-scss-module__H5YkTa__title",
  "toggle": "booking-widget-module-scss-module__H5YkTa__toggle",
  "wrapper": "booking-widget-module-scss-module__H5YkTa__wrapper",
});
